import { Star, StarHalf } from "lucide-react";
import { useState } from "react";

export default function StarRating({ 
  rating = 0, 
  onRatingChange = null, 
  size = "default",
  readonly = false 
}) {
  const [hoverRating, setHoverRating] = useState(0);
  
  const sizeClasses = {
    small: "w-4 h-4",
    default: "w-5 h-5",
    large: "w-6 h-6",
  };

  const starSize = sizeClasses[size];
  const displayRating = hoverRating || rating;

  const handleMouseMove = (e, starIndex) => {
    if (readonly) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const isLeftHalf = x < rect.width / 2;
    setHoverRating(isLeftHalf ? starIndex - 0.5 : starIndex);
  };

  const handleClick = (e, starIndex) => {
    if (readonly || !onRatingChange) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const isLeftHalf = x < rect.width / 2;
    const newRating = isLeftHalf ? starIndex - 0.5 : starIndex;
    onRatingChange(newRating);
  };

  const renderStar = (starIndex) => {
    const filled = displayRating >= starIndex;
    const halfFilled = !filled && displayRating >= starIndex - 0.5;

    return (
      <button
        key={starIndex}
        type="button"
        onClick={(e) => handleClick(e, starIndex)}
        onMouseMove={(e) => handleMouseMove(e, starIndex)}
        disabled={readonly}
        className={`relative ${readonly ? "cursor-default" : "cursor-pointer"} transition-transform duration-200 ${
          !readonly && "hover:scale-110"
        }`}
        data-testid={`star-${starIndex}`}
      >
        {halfFilled ? (
          <div className="relative">
            <Star className={`${starSize} text-muted-foreground/30`} />
            <div className="absolute inset-0 overflow-hidden w-1/2">
              <Star className={`${starSize} text-purple-400 fill-purple-400`} />
            </div>
          </div>
        ) : (
          <Star
            className={`${starSize} transition-colors duration-200 ${
              filled
                ? "text-purple-400 fill-purple-400"
                : "text-muted-foreground/30"
            }`}
          />
        )}
      </button>
    );
  };

  return (
    <div 
      className="flex items-center gap-0.5"
      onMouseLeave={() => !readonly && setHoverRating(0)}
      data-testid="star-rating"
    >
      {[1, 2, 3, 4, 5].map(renderStar)}
      {!readonly && displayRating > 0 && (
        <span className="ml-2 text-sm text-white/60">{displayRating}</span>
      )}
    </div>
  );
}
